import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "nav-lang-header"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["onClick", "onKeydown", "aria-label"];
import { computed, inject } from 'vue';
import { ArrowRightBold } from '@element-plus/icons-vue';
import { updateCurrentRoute } from '@/helpers/language';
import NavBarSimpleDropdown from './NavBarSimpleDropdown.vue';
export default {
  __name: 'NavMenuLang',
  setup(__props) {
    const localize = inject('localize');
    const enabledLangs = localize.getEnabledLangsAsISO();

    // Computed

    const activeLang = computed({
      get() {
        return localize.currCode.value;
      },
      set(value) {
        if (localize.hasLoaded.value) {
          updateCurrentRoute(value);
        }
      }
    });
    const Language = computed(() => {
      return enabledLangs.value?.find(entry => entry.code === activeLang.value) ?? {
        name: "ENG",
        origName: "English",
        code: "en"
      };
    });

    // Methods

    const handleLang = code => {
      activeLang.value = code;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(NavBarSimpleDropdown, {
        "aria-label": "Language Selection Dropdown"
      }, {
        "dropdown-content": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enabledLangs).filter(lang => lang.code !== activeLang.value), lang => {
          return _openBlock(), _createElementBlock("h4", {
            key: lang.code,
            tabindex: "0",
            role: "button",
            onClick: () => handleLang(lang.code),
            onKeydown: _withKeys(() => handleLang(lang.code), ["enter"]),
            notranslate: "",
            "aria-label": lang.origName
          }, _toDisplayString(lang.name), 41, _hoisted_3);
        }), 128))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", {
          notranslate: "",
          "aria-label": Language.value.origName
        }, _toDisplayString(Language.value.name), 9, _hoisted_2), _createVNode(_unref(ArrowRightBold), {
          class: "el-icon"
        })])]),
        _: 1
      });
    };
  }
};